/** @format */

import React from 'react';
import SuperAgent from 'superagent';
import Pusher from 'pusher-js';

export default function withCartTotalSubscription(ComponentContainer) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                cartId: parseInt(props.cartId),
                orderCount: props.order_count
            };
        }

        componentDidMount() {
            this.pusher = new Pusher(process.env.PUSHER_AUTH_KEY, {
                encrypted: true,
                cluster: process.env.PUSHER_CLUSTER,
                activityTimeout: 15000
            });
            this.handleSubscribeToggle(false);

            if (this.state.cartId === 0) {
                // We always pass 0 from wordress to force this update
                // Due to caching
                this.handleUpdateCartId();
            }
        }

        handleUpdateCartId = () => {
            // Set a timeout here so we don't get a session conflict.
            // If loading from wordpress, no session exists when calling get-current-user and get-totals at the same time
            // Duplicate session id entry error
            setTimeout(async () => {
                try {
                    const {
                        body: {cartId, orderCount}
                    } = await SuperAgent.get('/carts/get-totals').set('accept', 'application/json');
                    this.setState({cartId, orderCount});
                } catch (e) {}
            }, 500);
        };

        componentWillUnmount() {
            // If we don't do this, it will continue to try and update even when
            // The component isn't there. Which will throw a set state error complaining the
            // component does not exist
            this.handleSubscribeToggle(true);
        }

        handleSubscribeToggle = isSubscribed => {
            if (isSubscribed) {
                this.pusher.unsubscribe(process.env.PUSHER_CART_UPDATE_CHANNEL);

                this.orderUpdatesChannel.unbind(
                    process.env.PUSHER_CART_UPDATE_EVENT,
                    this.updateTotal
                );
            } else {
                this.orderUpdatesChannel = this.pusher.subscribe(
                    process.env.PUSHER_CART_UPDATE_CHANNEL
                );

                this.orderUpdatesChannel.bind(
                    process.env.PUSHER_CART_UPDATE_EVENT,
                    this.updateTotal
                );
            }
        };

        updateTotal = data => {
            if (data.cart_id == this.state.cartId) {
                this.setState({orderCount: data.order_count});
            }
        };

        render() {
            const props = {...this.props};

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
}
